/**
 * i18n namespaces. Each maps 1:1 to a `locales/<locale>/<namespace>.json` file.
 *
 * Adding a namespace:
 *  1. Add it to this array
 *  2. Create `locales/<locale>/<new>.json` in all SUPPORTED_LOCALES
 *  3. Run `pnpm i18n:check` to verify the key sets are aligned
 */
export const NAMESPACES = [
    'common',
    'auth',
    'errors',
    'dashboard',
    'emails',
    'banking',
    'business_model',
];
export const DEFAULT_NAMESPACE = 'common';
//# sourceMappingURL=namespaces.js.map